import React, {useState} from 'react';
import {NavLink} from "react-router-dom";
import {Col, Divider, Row, Breadcrumb, Typography} from "antd";
import {HomeOutlined} from "@ant-design/icons";

import PatientsList from "./PatientsList";

const PatientsManagement = () => {
    const [patientsList, setPatientsList] = useState([]);


    return <Row justify="center">

        <Col xs={24}>
            <Breadcrumb>
                <Breadcrumb.Item>
                    <NavLink to={'/'}>
                        <HomeOutlined/>&nbsp;
                        Dashboard
                    </NavLink>
                </Breadcrumb.Item>

                <Breadcrumb.Item>
                    Patient List
                </Breadcrumb.Item>
            </Breadcrumb>

            <Typography.Title level={1}>Patient List</Typography.Title>
        </Col>

        <Col xs={24}>
            <Divider/>
            <PatientsList patientsList={patientsList} setPatientsList={setPatientsList}/>
        </Col>

    </Row>;
}

export default PatientsManagement;